import UserProfileModal from "./user-profile-modal";

export default UserProfileModal;